"use strict";

var QueryStringHelper = require("../shared/QueryStringHelper");
var WizardConstants = require("../constants/WizardConstants");

var parentComponentSelector = "[data-component='tsysTsepCreditCardPayment']";
var iframeSelector = "iframe[data-tsys-tsep-iframe]";

var TsysTsepHelper = {
	initializeTsysTsep: function($parent) {
		$parent = $parent || $("body");

		$parent.find(parentComponentSelector).each((index, element) => {
			var $element = $(element);
			$element.attr("data-has-custom-validator", true).data({customValidator: this.validateTsysTsepResult.bind(this, $element)});
		});
	},

	//selector can be a jQuery object or jQuery selector
	isTsysTsep: function(selector) {
		var $selector = $(selector || "body");
		return Boolean(
			$selector.closest(parentComponentSelector).length || $selector.find(parentComponentSelector).length
		);
	},

	setTsysIframeHeight: function(uniqueId, height) {
		var $element = $(`[data-unique-id="${uniqueId}"]`);
		var $iframe = $element.find(iframeSelector);
		$iframe.height(height);
	},

	syncTsysTsepResult: function(uniqueId, result) {
		var $element = $(`[data-unique-id="${uniqueId}"]`);
		$element.data({tsysTsepResult: result});
		if (result.tsepToken && result.deferred && !result.tokenHandled) {
			//If we were waiting for a token, let's go ahead and return it.
			result.tokenHandled = true;
			result.deferred.resolve(this.getValidationResponse(/*hasError*/false));
		}
	},

	getTsysTsepResult: function($element) {
		if (this.isTsysTsep($element)) {
			if ($element.data("tsysTsepResult") && $.isPlainObject($element.data("tsysTsepResult"))) {
				var result = $element.data("tsysTsepResult");
				return result;
			}
		}

		return null;
	},

	validateTsysTsepResult: function($element) {
		var uniqueId = $element.attr("data-unique-id");
		var queryParameters = {
			uniqueId
		};

		var result = this.getTsysTsepResult($element);
		if (!result) {
			queryParameters.isCardNumberValid = false;
			queryParameters.isExpirationDateValid = false;
			queryParameters.isVerificationNumberValid = false;

			//No deferred is returned
			return this.getValidationResponse(/*hasError*/true, /*errorMessages*/null, $element, queryParameters);
		} else if (!result.tsepToken) {
			//We have no token; see how many valid fields we have
			var validCount = this.getValidCount(result);

			if (validCount == 2) {
				//We have two valid fields, let's wait half a second to see if we have three valid as the submit and the focusOut could happen at the same time.
				result.deferred = new $.Deferred();
				window.setTimeout(() => {
					result = this.getTsysTsepResult($element);
					//If the token has already been handled, we do not need to do anything else
					if (result && !result.tokenHandled) {
						if (!result.tsepToken) {
							validCount = this.getValidCount(result);
							if (validCount == 3) {
								this.handleThreeValidFieldButNoToken(result.deferred, $element, queryParameters);
							} else {
								//We do not have three valid fields, so we are definitely not valid
								result.deferred.resolve(this.hasNoTokenResponse(result, $element, queryParameters));
							}
						} else {
							//There is no error.
							result.deferred.resolve(this.getValidationResponse(/*hasError*/false));
						}
					}
				}, 500);
				return {deferred: result.deferred};
			} else if (validCount == 3) {
				result.deferred = new $.Deferred();
				this.handleThreeValidFieldButNoToken(result.deferred, $element, queryParameters);
				return {deferred: result.deferred};
			}

			//No deferred is returned.  We do not have a token and only 0 or 1 TSYS TSEP field is valid.
			return this.hasNoTokenResponse(result, $element, queryParameters);
		}

		//No deferred.  There is no error.
		return	this.getValidationResponse(/*hasError*/false);
	},

	handleThreeValidFieldButNoToken: function(deferred, $element, queryParameters) {
		//We have three valid fields, but no token.  Let's wait 5 seconds to see if we get a token.
		window.setTimeout(() => {
			var result = this.getTsysTsepResult($element);
			//If token has been handled, we do not need to do anything else.
			if (result && !result.tokenHandled) {
				if (!result.tsepToken) {
					deferred.resolve(this.hasNoTokenResponse(result, $element, queryParameters));
				} else {
					//No Error, we have the token
					//There is no error.
					deferred.resolve(this.getValidationResponse(/*hasError*/false));
				}
			}
		}, 5000);
	},

	hasNoTokenResponse: function(result, $element, queryParameters) {
		var hasError = true;
		var errorMessages = [];

		queryParameters.isCardNumberValid = false;
		queryParameters.cardNumberErrorMessage = result.cardNumber.errorMessage || null;

		queryParameters.expirationDate = (result.expirationDate.isValid && result.expirationDate.value) || null;
		queryParameters.isExpirationDateValid = result.expirationDate.isValid;
		queryParameters.expirationDateErrorMessage = result.expirationDate.errorMessage || null;

		queryParameters.verificationNumber = (result.verificationNumber.isValid && result.verificationNumber.value) || null;
		queryParameters.isVerificationNumberValid = result.verificationNumber.isValid;
		queryParameters.verificationNumberErrorMessage = result.verificationNumber.errorMessage || null;

		errorMessages.push(result.cardNumber.errorMessage);
		errorMessages.push(result.expirationDate.errorMessage);
		errorMessages.push(result.verificationNumber.errorMessage);
		errorMessages.push(result.errorMessage);

		errorMessages = errorMessages.filter(Boolean);

		if (!result.cardNumber.value || !result.expirationDate.value || !result.verificationNumber.value) {
			errorMessages.push(window.FORM_VALIDATION_MESSAGES.REQUIRED_FIELDS);
		}

		return this.getValidationResponse(hasError, errorMessages, $element, queryParameters);
	},

	getValidationResponse: function(hasError, errorMessages, $element, queryParameters) {
		errorMessages = errorMessages || [];
		if (hasError && !errorMessages.length) {
			var genericErrorMessage = this._getStore().getWizardValue(
				WizardConstants.WIZARDS.COMPANY_ERROR_MESSAGES,
				WizardConstants.TSYS_TSEP_MESSAGE_FIELDS.GENERIC
			);
			errorMessages.push(genericErrorMessage);
		}

		if (errorMessages.length) {
			$element.removeData("tsysTsepResult");

			var $iframe = $element.find(iframeSelector);
			var url = $iframe.attr("src").split("?")[0];
			var queryParametersString = QueryStringHelper.createQueryString(queryParameters);
			$iframe.attr("src", `${url}?${queryParametersString}`);
		}

		return {
			errorMessages: errorMessages,
			isValid: !errorMessages.length
		};
	},

	getValidCount: function (result) {
		var validCount = 0;
		if (result.cardNumber.isValid) {
			validCount++;
		}
		if (result.expirationDate.isValid) {
			validCount++;
		}
		if (result.verificationNumber.isValid) {
			validCount++;
		}
		return validCount;
	},

	getCardType: function (cardType) {
		switch (cardType) {
			case "V":
				return "VISA";
			case "M":
				return "MASTERCARD";
			case "X":
				return "AMEX";
			case "R":
				return "DISCOVER";
			case "J":
				return "JCB";
			default:
				return cardType;
		}
	},

	_getStore: function() {
		if (window.CheckoutStore) {
			return window.CheckoutStore;
		}

		return window.AccountStore;
	},
};

module.exports = TsysTsepHelper;
